var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","height":"64px","extension-height":_vm.extensionHeight}},[_vm._t("default"),_c('template',{slot:"extension"},[_vm._t("extension")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }